module.exports = __webpack_public_path__ + "img/cy.cy8a3f7e5.svg";